import { render, staticRenderFns } from "./DutyCreate.vue?vue&type=template&id=6012a220&scoped=true"
import script from "./DutyCreate.vue?vue&type=script&lang=js"
export * from "./DutyCreate.vue?vue&type=script&lang=js"
import style0 from "./DutyCreate.vue?vue&type=style&index=0&id=6012a220&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012a220",
  null
  
)

export default component.exports